import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Component, OnInit, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { NotificationService, LoaderService, CONSTANT, EVENTO, TOOLTIPS, ICONS, ACTIONS, UtilityService } from "../../../../shared/session/index";
import { User } from "../shared/user.model";
import { UserService } from '../shared/user.service';
import { RegularExpressionMessage, RegularExpression, CustomValidators } from '../../../../shared/validation/customvalidation';
import { FileuploadComponent } from 'src/app/shared/fileupload/fileupload.component';

@Component({
  selector: 'app-user-edit',
  templateUrl: 'user-edit.component.html'
})
export class UserEditComponent implements OnInit {
  @Output() onChangeEvent: EventEmitter<any> = new EventEmitter();
  @Input() data: any;
  @Input() titlePage: string;
  @ViewChild('imagenAnversoComponent') imagenAnversoComponent: FileuploadComponent;
  @ViewChild('imagenReversoComponent') imagenReversoComponent: FileuploadComponent;

  formGrupEditUser: FormGroup;
  buttonGroup: any;
  user: User;
  nomUserMaxLength: number;
  descripcionMaxLength: number;
  msgErrorActualizar: string;
  msgErrorGet: string;
  obligatorioMsg: string;
  maxLengthMsg: string;
  nomUserPatternMsg: string = RegularExpressionMessage.LETRAS_TILDE_ENIE_MSG;
  onlyNumber: string = RegularExpressionMessage.SOLO_NUMERO_MSG;
  nomPathMaxLength: number;
  public typeImage: number;
  DNImaxLength: number;

  constructor(
    private loaderService: LoaderService,
    private userService: UserService,
    private notificationService: NotificationService,
    public utilityService: UtilityService,
    public fb: FormBuilder
  ) { }

  ngOnInit() {
    this.buttonGroup = [
      { tooltip: TOOLTIPS.save, icon: ICONS.save, action: ACTIONS.save }
    ];
    this.msgErrorActualizar = 'Error al actualizar datos';
    this.msgErrorGet = 'Error al obtener datos';
    this.obligatorioMsg = 'Campo Obligatorio';
    this.user = new User();
    this.DNImaxLength = 8;
    this.nomUserMaxLength = 100;
    this.descripcionMaxLength = 250;
    this.typeImage = CONSTANT.typeImage.edit;
    this.setValuesFormBuilder();
    this.obtenerUser(this.data.user.ID);
  }

  setValuesFormBuilder() {
    this.formGrupEditUser = this.fb.group({
      UserName: [this.user.UserName, Validators.compose([
        Validators.required,
        Validators.maxLength(this.nomUserMaxLength),
        CustomValidators.pattern(RegularExpression.LETRAS_TILDE_ENIE)
      ])],
      UserShortName: [this.user.UserShortName, Validators.compose([
        Validators.required,
        Validators.maxLength(this.nomUserMaxLength),
        CustomValidators.pattern(RegularExpression.LETRAS_TILDE_ENIE)
      ])],
      Description: [this.user.Description, Validators.compose([
        Validators.maxLength(this.descripcionMaxLength),
        CustomValidators.pattern(RegularExpression.LETRAS_TILDE_ENIE)
      ])],
      Password: [this.user.Password, Validators.compose([
        Validators.maxLength(this.descripcionMaxLength),
      ])],
      DNI: [this.user.DNI, Validators.compose([
        Validators.maxLength(this.descripcionMaxLength),
        CustomValidators.pattern(RegularExpression.SOLO_NUMERO)
      ])],
      Direccion: [this.user.Direccion, Validators.compose([
        Validators.maxLength(this.descripcionMaxLength),
      ])],
      Telefono: [this.user.Telefono, Validators.compose([
        Validators.maxLength(this.descripcionMaxLength),

      ])],
      Correo: [this.user.Correo, Validators.compose([
        Validators.maxLength(this.descripcionMaxLength),
      ])],
      FechaNac: [this.user.FechaNac, Validators.compose([Validators.required,])],
      FechaIng: [this.user.FechaIng, Validators.compose([Validators.required,])],
      status: [this.user.Status],
      seguimiento: [this.user.seguimiento],
      editarToken: [this.user.editarToken],
      multipleSesion: [this.user.multipleSesion],
      seguimientoUbicacion: [this.user.seguimientoUbicacion],
      autonomia: [this.user.autonomia],
    });
  }

  formGrupEditUserSubmit(event) {
    if (this.formGrupEditUser.invalid)
      return;
    this.user.UserName = event.value.UserName;
    this.user.UserShortName = event.value.UserShortName;
    this.user.Password = event.value.Password;
    this.user.Description = event.value.Description;
    this.user.DNI = event.value.DNI;
    this.user.Direccion = event.value.Direccion;
    this.user.Telefono = event.value.Telefono;
    this.user.Correo = event.value.Correo;
    this.user.FechaNac = event.value.FechaNac;
    this.user.FechaIng = event.value.FechaIng;
    this.user.Status = event.value.status
    this.user.seguimiento = event.value.seguimiento;
    this.user.editarToken = event.value.editarToken;
    this.user.multipleSesion = event.value.multipleSesion;
    this.user.seguimientoUbicacion = event.value.seguimientoUbicacion;
    this.user.autonomia = event.value.autonomia;

    this.imagenAnversoComponent.insertFile(CONSTANT.imagen.clase.imagen, CONSTANT.imagen.tipo.usuario, this.user.FotoRuta, this.user.DNI.toString());
    this.imagenReversoComponent.insertFile(CONSTANT.imagen.clase.imagen, CONSTANT.imagen.tipo.usuario, this.user.imagenReverso, this.user.DNI.toString());

    (this.imagenAnversoComponent.imageName) ? this.user.FotoRuta = this.imagenAnversoComponent.imageName : this.user.FotoRuta = '';
    (this.imagenReversoComponent.imageName) ? this.user.imagenReverso = this.imagenReversoComponent.imageName : this.user.imagenReverso = '';

    this.user.claseArchivo = CONSTANT.imagen.clase.imagen;
    if (this.user.FotoRuta == "") {
      this.notificationService.error("Debe subir la primera imagen")
      return;
    } else {
      this.actualizarUser(this.user);
    }
  }

  changeEvent(user: User) {
    this.data = { user: { ID: user.ID, Name: user.UserName } };
    this.onChangeEvent.emit({ evento: EVENTO.consultar, data: this.data });
  }

  actualizarUser(user: User) {
    this.loaderService.show();
    this.userService.actualizarUser(user)
      .subscribe(res => {
        this.changeEvent(user);
      },
        error => {
          this.notificationService.error(error.error.message || this.msgErrorActualizar);
          throw error;
        },
        () => {
          this.loaderService.hide();
        });
  }

  obtenerUser(userID: number): void {
    this.loaderService.show();
    this.userService.obtenerUser(userID)
      .subscribe(res => {
        this.user = res;
        this.imagenAnversoComponent.getFile(CONSTANT.imagen.clase.imagen, CONSTANT.imagen.tipo.usuario, this.user.FotoRuta);
        this.imagenReversoComponent.getFile(CONSTANT.imagen.clase.imagen, CONSTANT.imagen.tipo.usuario, this.user.imagenReverso);
      },
        error => {
          this.notificationService.error(this.msgErrorGet);
          throw error;
        },
        () => {
          this.setValuesFormBuilder();
          this.loaderService.hide();
        });
  }

  onlyDecimalNumberKey(event, value) {
    let charCode = (event.which) ? event.which : event.keyCode;
    if (charCode == 46 && String(value).indexOf('.') > 0)
      return false;

    if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57))
      return false;
    return true;
  }
}
